<template>
  <div v-if="show" class="flex flex-col h-screen bg-black dir-rtl main-menu">
    <ul class="menu">
      <li>
        <img src="@/assets/img/place_holder.jpg" class="menu-pic" />
        {{ profile.mobile }}
      </li>

      <li>
        <img src="@/assets/icons/menu_profile.svg" class="menu-icon" />
        <router-link to="/profile"> حساب کاربری </router-link>
      </li>
      <li>
        <img src="@/assets/icons/menu_notification.svg" class="menu-icon" />
        <router-link to="/notificationsetting"> تنظیمات اعلان</router-link>
      </li>
      <li>
        <img src="@/assets/icons/menu_security.svg" class="menu-icon" />
        <router-link to="/securitysetting"> امنیت </router-link>
      </li>
      <li>
        <img src="@/assets/icons/menu_privacy.svg" class="menu-icon" />
        <router-link to="/"> حریم خصوصی </router-link>
      </li>
    </ul>
    <div class="sperator"></div>
    <ul class="menu">
      <li>
        <img src="@/assets/icons/menu_team.svg" class="menu-icon" />
        <router-link to="/inviteother"> دعوت از دیگران </router-link>
      </li>
    </ul>
    <div class="sperator"></div>
    <ul class="menu">
      <li>
        <img src="@/assets/icons/menu_help.svg" class="menu-icon" />
        <router-link to="/support"> پشتیبانی </router-link>
      </li>
      <div class="version">
        <p style="margin-left: 14px">1.0.0</p>
        <img src="@/assets/icons/menu_approval.svg" class="menu-icon" />
      </div>
      <li>
        <img src="@/assets/icons/menu_update.svg" class="menu-icon" />
        <router-link to="/"> به‌روزرسانی </router-link>
      </li>
      <li>
        <img src="@/assets/icons/menu_team.svg" class="menu-icon" />
        <router-link to="/"> درباره‌ما </router-link>
      </li>
      <li>
        <img src="@/assets/icons/menu_logout.svg" class="menu-icon" />
        <router-link to="/logout"> خروج از حساب کاربری </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
  },
  beforeMount() {
    if (this.profile == undefined) {
      this.loadData();
    }
  },
  data() {
    return {
      profile: undefined,
    };
  },
  methods: {
    loadData() {
      this.$store.dispatch("user/profile").then((rspon) => {
        this.profile = rspon;
      });
    },
  },
};
</script>

<style></style>
